var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',[(_vm.loading)?_c('v-overlay',{attrs:{"absolute":"","z-index":"100","color":_vm.overlayColor}},[_c('v-progress-circular',{staticClass:"darken-1 loader",attrs:{"absolute":"","indeterminate":"","size":_vm.size,"color":_vm.loaderColor}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }